import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../BaseComponent';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-master-data',
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.scss']
})
export class MasterDataComponent extends BaseComponent implements OnInit {

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute) {
    super(route, router);

  }

  ngOnInit() {
  }

  returnMasterData(url: string, pathRelative: string) {
      if (url === '/master-data' + pathRelative) {
        this.router.navigate(['/master-data']);
      } else {
        this.router.navigate(['/master-data' + pathRelative]);
      }
  }

  returnZero() {
    return 0;
  }
}
